module.exports = __webpack_public_path__ + "img/87.ce1d5e95.jpg";